"use client";

type LandingWowExperienceProps = {
  businessName: string;
  businessType: string;
  website: string;
  selectedPlace: any;
  glowLoading: boolean;
  glowResult: any;
  glowStatus: string;
  onStartFree: () => void;
  onStartPro: () => void;
};

export default function LandingWowExperience({
  onStartFree,
  onStartPro,
}: LandingWowExperienceProps) {
  function startCheckup() {
    onStartFree();

    window.setTimeout(() => {
      document
        .getElementById("business-name-input")
        ?.focus();
    }, 450);
  }

  return (
    <section className="mx-auto max-w-7xl px-4 pb-5 pt-4 sm:px-6 sm:pb-7 sm:pt-7">
      <div className="grid items-center gap-4 lg:grid-cols-[1.05fr_1fr] lg:gap-x-10 lg:gap-y-5">
        <div className="lg:col-start-1 lg:row-start-1">
          <h1 className="text-[2.25rem] font-light leading-[1.04] tracking-[-0.05em] text-[#102521] sm:text-5xl xl:text-[3.5rem]">
            You’ve always wanted to clone yourself.{" "}
            <span className="text-[#102521] decoration-[#ff5a3d] underline decoration-4 underline-offset-4">Now you don’t need to.</span>
          </h1>
          <p className="mt-4 max-w-xl text-base font-light leading-6 text-[#52635f] sm:text-lg sm:leading-7">
            Meet MarginGlow, your AI growth desk. Get practical help to find more customers,
            cut costs and grow your business. You don’t need to clone yourself for more capacity.
          </p>
        </div>
        <figure className="lg:col-start-2 lg:row-span-3 lg:row-start-1">
        <picture className="block overflow-hidden rounded-3xl border border-[#d7e5df] bg-[#eee9df]">
          <source
            type="image/avif"
            srcSet="/hero-clone-v1/owner-480.avif 480w, /hero-clone-v1/owner-800.avif 800w, /hero-clone-v1/owner-1200.avif 1200w"
            sizes="(min-width: 1280px) 580px, (min-width: 1024px) 46vw, calc(100vw - 32px)"
          />
          <img
            src="/hero-clone-v1/owner-800.webp"
            srcSet="/hero-clone-v1/owner-480.webp 480w, /hero-clone-v1/owner-800.webp 800w, /hero-clone-v1/owner-1200.webp 1200w"
            sizes="(min-width: 1280px) 580px, (min-width: 1024px) 46vw, calc(100vw - 32px)"
            width={1536}
            height={1024}
            alt="Even her clone is busy: two versions of a shop owner juggle receipts, customer calls and parcels."
            loading="eager"
            fetchPriority="high"
            decoding="async"
            className="h-auto max-h-[200px] w-full object-cover object-center sm:max-h-[320px] lg:max-h-none"
          />
        </picture>
          <figcaption className="mt-2 text-xs text-[#52635f]">AI-generated illustration.</figcaption>
        </figure>
        <div className="lg:col-start-1 lg:row-start-2">
          <p className="mb-3 text-sm font-medium text-[#007c7a]">
            Open your free account now, with $10/€10 FREE task tokens built in!
          </p>
          <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
            <button type="button" onClick={startCheckup}
              className="rounded-2xl bg-[#007c7a] px-6 py-3.5 text-base font-normal text-white shadow-xl shadow-[#007c7a]/20 transition hover:bg-[#006b69]">
              Start my Free Business Check-up
            </button>
            <button type="button" onClick={onStartPro}
              className="rounded-2xl bg-[#ff5a3d] px-6 py-3.5 text-base font-normal text-[#102521] shadow-xl shadow-[#ff5a3d]/20 transition hover:bg-[#ff765e]">
              Get MarginGlow Pro
            </button>
          </div>
        </div>
        <details className="text-sm font-light leading-6 text-[#5f706b] lg:col-start-1 lg:row-start-3">
          <summary className="cursor-pointer py-2 font-medium text-[#007c7a] focus-visible:outline-2 focus-visible:outline-offset-4">Easy Pricing</summary>
          <p className="mt-2">
          Start free. Get MarginGlow Pro, including your full Business Scan, for €7 or US$7 per month + VAT where applicable. Your first payment starts your first month. No separate activation fee. Renews monthly until cancelled.
          </p>
        </details>
      </div>
    </section>
  );
}
